/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CredentialsResetDto } from '../models/CredentialsResetDto';
import type { ForgotPasswordDto } from '../models/ForgotPasswordDto';
import type { ForgotPasswordResponse } from '../models/ForgotPasswordResponse';
import type { ResetPasswordDto } from '../models/ResetPasswordDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class PasswordService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns ForgotPasswordResponse Success
     * @throws ApiError
     */
    public postApiAccountsForgotPassword(
        requestBody?: ForgotPasswordDto,
    ): CancelablePromise<ForgotPasswordResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/accounts/forgotPassword',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiAccountsResetPassword(
        requestBody?: ResetPasswordDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/accounts/resetPassword',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiAccountsResetCredentials(
        requestBody?: CredentialsResetDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/accounts/reset-credentials',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
}
